import TextField from 'components/forms/textField/TextField';
import { useTranslation } from 'react-i18next';

const NameField = () => {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('pageProperty.seasonality.modal.fields.name.label')}
      name="name"
      placeholder={t('pageProperty.seasonality.modal.fields.name.placeholder')}
      colSmLabel={12}
      colSmInput={12}
      required
      labelOnTop
    />
  );
};

export default NameField;
